import React from 'react';
import Resource from '../../../common/Resource'
import Panel from '../../../common/layout/Panel'

export default class extends React.Component {
    render () {
        const data = {
            url: `/admin/routing/sms/groups`,
            data: {
                data: [],
                metadata: []
            },
            metadata:
                [
                    {
                        'label': 'id',
                        'source': 'ATRSMSROUTINGGROUPID',
                        'type': 'primary',
                        'editable': false,
                        'visible': false
                    },
                    {
                        'label': 'Routing Group Name',
                        'source': 'ATRNAME',
                        'type': 'text',
                        'editable': true,
                        'visible': true,
                        'placeholder': 'New Routing group...'
                    },
                    {
                        'label': 'Enabled',
                        'source': 'ATRSTATUS',
                        'type': 'checkbox',
                        'editable': true,
                        'visible': true,
                        'default' : true
                    },
                    {
                        label: 'View',
                        value: '/routing/sms/groups/{$id}',
                        type: 'link'
                    },
                    {
                        'label' : 'Actions',
                        'type': 'action_buttons'
                    }
                ]
        }
        return (
            <Panel title = "SMS Routing Groups">
                <Resource
                    addButtonText = "Add SMS Routing Group"                    
                    data = {data}
                    {...this.props} 
                />
            </Panel>
        )
    }
}
    